import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { addFlashMessage } from "../actions/flashMessages";
import { setRedirectPath } from "../actions/authActions";

export default function(ComposedComponent) {
  class Authenticate extends React.Component {
    componentWillMount() {

      if (!this.props.isAuthenticated) {
        //this.context.router.history.push("/login");
        this.props.setRedirectPath(this.props.location.pathname,
            ...(this.props.location.state || {}), null);
        this.context.router.history.push({
          pathname: "/login",
          state: {
            redirect: this.props.location.pathname,
            ...(this.props.location.state || {})
          }
        });
      }
    }

    componentWillUpdate(nextProps) {
      if (!nextProps.isAuthenticated) {
        this.context.router.history.push("/");
      }
    }
    render() {
      return <ComposedComponent {...this.props} />;
    }
  }

  Authenticate.propTypes = {
    isAuthenticated: PropTypes.bool.isRequired,
    addFlashMessage: PropTypes.func.isRequired
  };

  Authenticate.contextTypes = {
    router: PropTypes.object.isRequired
  };

  function mapStateToProps(state) {
    return {
      isAuthenticated: state.auth.isAuthenticated
    };
  }

  return connect(
      mapStateToProps,
      { addFlashMessage, setRedirectPath }
  )(Authenticate);
}



// WEBPACK FOOTER //
// ./src/modules/utils/requireAuth.js